import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface KeyValueItem {
  label: string;
  value: string;
}

export interface KeyValueContent {
  items: KeyValueItem[];
}

@Component({
  selector: 'app-key-value',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './key-value.component.html',
  styleUrl: './key-value.component.scss',
})
export class KeyValueComponent {
  @Input() content!: KeyValueContent;
}

